import { Breakpoint as i } from "../utils/enums.js";
const t = {
  [i.Xs]: {
    mediaQuery: "(min-width: 0) and (max-width: 575px)",
    screenWidthRange: "0 - 575px",
    minScreenWidth: "0px",
    maxScreenWidth: "575px",
    containerMaxWidth: "100%",
    viewportWidth: 360
  },
  [i.Sm]: {
    mediaQuery: "(min-width: 576px) and (max-width: 767px)",
    screenWidthRange: "576px - 767px",
    minScreenWidth: "576px",
    maxScreenWidth: "767px",
    containerMaxWidth: "520px",
    viewportWidth: 767
  },
  [i.Md]: {
    mediaQuery: "(min-width: 768px) and (max-width: 1023px)",
    screenWidthRange: "768px - 1023px",
    minScreenWidth: "768px",
    maxScreenWidth: "1023px",
    containerMaxWidth: "740px",
    viewportWidth: 962
  },
  [i.Lg]: {
    mediaQuery: "(min-width: 1024px) and (max-width: 1199px)",
    screenWidthRange: "1024px - 1199px",
    minScreenWidth: "1024px",
    maxScreenWidth: "1199px",
    containerMaxWidth: "960px",
    viewportWidth: 1180
  },
  [i.Xl]: {
    mediaQuery: "(min-width: 1200px) and (max-width: 1499px)",
    screenWidthRange: "1200px - 1499px",
    minScreenWidth: "1200px",
    maxScreenWidth: "1499px",
    containerMaxWidth: "1160px",
    viewportWidth: 1366
  },
  [i.Xxl]: {
    mediaQuery: "(min-width: 1500px)",
    screenWidthRange: "1500px and above",
    minScreenWidth: "1500px",
    maxScreenWidth: "1500px",
    containerMaxWidth: "1160px",
    viewportWidth: 1920
  }
};
export {
  t as BREAKPOINT_DETAILS
};
